import { ITariffSort, TARIFF_SORTS } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IListGateway } from '../gateways';
import { AppConfigService } from '../../app-config.service';
import { inject } from '@angular/core';

export class SortsGateway implements IListGateway<
  string,
  IApiResponse<ITariffSort[]>
> {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly restCallBuilder: RestCallBuilder<ITariffSort[]> =
    new RestCallBuilder<ITariffSort[]>([]);

  list(): Observable<IApiResponse<ITariffSort[]>> {
    return this.restCallBuilder
      .getExternal(
        this.configService.get().general.tariffUrl + '/tariff/sorts',
        {
          tariffAreaId: 0, // @TODO where do we get this from, it is NOT the serviceAreaId
        }
      )
      .validate(API_RESPONSE_SCHEMA(TARIFF_SORTS), 'TariffSort.get')
      .handleMessages()
      .build();
  }
}
